export default function() {

  try {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone) {
      // Set a cookie that the server can read
      document.cookie = 'browser_time_zone=' + encodeURIComponent(timeZone) + '; path=/; max-age=86400';
      
      // Also store in sessionStorage for immediate use
      sessionStorage.setItem('browser_time_zone', timeZone);
    }
  } catch (e) {
    console.warn('Unable to detect timezone:', e);
  }

}